import React from "react";
import { Col, Row } from "antd";
import "./Login.scss";

const AvanceAcre = (props) => {
    const {estadisticas} = props;

    const obtenerAbreviaturaEntidad = nombreEntidad => {
        if(nombreEntidad !== undefined) {
            // eslint-disable-next-line
            return nombreEntidad.replace(/\./g,"").replace(/\ /g,"");
        } else {
            return "";
        }
    }

    const formatPorcentaje = numOriginal => {
        var resultado = "";
        resultado = Number(numOriginal).toFixed(2);
        resultado.toString();
        return resultado;
    };

    return (
        <div>
            <Row>
                <Col span={12}>
                    <div className={"entidadMayorMenor "+obtenerAbreviaturaEntidad(estadisticas.abreviaturaMaxAcre)}></div>
                    <p className="mayorMenorTitulo">Mayor</p>
                    <p className="mayorMenorTitulo"><b>{estadisticas.nombreEstadoMaxAcre}</b></p>
                    <p className="mayorMenorPorcentaje"><b>{formatPorcentaje(estadisticas.porcentajeMaxAcre)}%</b></p>
                    <p>
                        <b>{estadisticas.acreditadasMaxAcre}</b> solicitud(es) acreditada(s) de {estadisticas.capacitadasMaxAcre}
                        &nbsp;capacitada(s).
                    </p>
                </Col>
                <Col span={12}>
                    <div className={"entidadMayorMenor "+obtenerAbreviaturaEntidad(estadisticas.abreviaturaMinAcre)}></div>
                    <p className="mayorMenorTitulo">Menor</p>
                    <p className="mayorMenorTitulo"><b>{estadisticas.nombreEstadoMinAcre}</b></p>
                    <p className="mayorMenorPorcentaje"><b>{formatPorcentaje(estadisticas.porcentajeMinAcre)}%</b></p>
                    <p>
                        <b>{estadisticas.acreditadasMinAcre}</b> solicitud(es) acreditada(s) de {estadisticas.capacitadasMinAcre}
                        &nbsp;capacitada(s).
                    </p>
                </Col>
            </Row>
        </div>
    );

}

export default AvanceAcre;